const PREFIX = "@HIGHGROUND_GLOBAL_";

export const COMPANY_DETAIL = `${PREFIX}COMPANY_DETAIL`;
